import type { Badge, AccountBadge } from '@olimhub/shared'
import { apiClient } from '../client'

export const badgesApi = {
  getAll: () =>
    apiClient.get<Badge[]>('/badges').then((r) => r.data),

  getForAccount: (username: string) =>
    apiClient.get<AccountBadge[]>(`/accounts/${username}/badges`).then((r) => r.data),

  grant: (username: string, badgeSlug: string, level?: number) =>
    apiClient
      .post<AccountBadge>(`/accounts/${username}/badges`, { badgeSlug, level })
      .then((r) => r.data),

  revoke: (accountBadgeId: string) =>
    apiClient.delete(`/badges/grant/${accountBadgeId}`).then((r) => r.data),
}
